import { Grid, Stack, Typography, useTheme } from "@mui/material";
import { AppImages } from "app/appImages";
import { MprcClickable } from "components";
import { MprcMediaViewer } from "components/MprcMediaViewer";
import { FileGetDto } from "generated/CoreApi_v1";
import MediaUtils from "lib/MediaUtils";
import React, { useState } from "react";

interface IProps {
  attach: FileGetDto;
}

export const DevPlanMediaView: React.FC<IProps> = (props) => {
  const { attach } = props;

  const theme = useTheme();

  const [openMediaView, setOpenMediaView] = useState<boolean>(false);

  const handleViewAttach = () => {

    if (attach.mimetype.startsWith("image") || attach.mimetype.startsWith("video"))
      setOpenMediaView(true);
    else
      MediaUtils.openFileViewerOrDownloadUrl(attach.metadata.filename, attach.url);
  };

  function getThumbnailFromAttach() {
    if (attach.mimetype && attach.metadata.filename && MediaUtils.isVideoOrAudio(attach.mimetype)) {
      return <img src={AppImages.VideoMp4Thumbnail} width={20} />;
    }

    if (attach.mimetype && attach.metadata.filename && MediaUtils.isAudio(attach.mimetype)) {
      return <img src={AppImages.AudioThumbnail} width={20} />;
    }

    if (attach.mimetype && attach.metadata.filename && MediaUtils.isImage(attach.mimetype)) {
      return <img src={AppImages.EmptyImageThumbnail} width={20} />;
    }

    if (attach.mimetype && attach.metadata.filename) {
      return <img src={MediaUtils.getFileIcon(attach.metadata.filename)} width={20} />;
    }

    return null;
  }

  return (
    <>
      <MprcMediaViewer
        open={openMediaView}
        file={attach}
        onClose={() => setOpenMediaView(false)}
      />
      <Stack sx={{ backgroundColor: theme.palette.paper.dark, borderRadius: 4, width: "fit-content" }}>
        <MprcClickable onClick={() => handleViewAttach()}>
          <Grid container alignItems="center" justifyContent="center" spacing={1} paddingLeft={2} paddingRight={3} paddingTop={0.7} paddingBottom={0.3}>
            <Grid>
              {getThumbnailFromAttach()}
            </Grid>
            {
              attach.metadata.filename &&
              <Grid>
                <Typography variant="caption" fontWeight="bold" color={theme.palette.text.primary}>
                  {attach.metadata.filename}
                </Typography>
              </Grid>
            }
          </Grid>
        </MprcClickable>
      </Stack>
    </>
  );
};
